var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"total-visible":"6","prev-icon":"$vuetify.icons.arrowLeft","next-icon":"$vuetify.icons.arrowRight","value":_vm.value,"length":_vm.totalPageCount},on:{"input":function($event){return _vm.changePage($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }